import InputAdornment from "@mui/material/InputAdornment";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useEffectAsync } from "designSystem/hooks";
import { GridColumn, GridRow, IconButton, OverflowText, SingleSelect, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { HiggMaterialComposition, useHiggMaterialStore } from "./HiggMaterialStore";

const PREFIX = "HiggMaterialCompositionSingleItem";

const classes = {
	compositionContainer: `${PREFIX}compositionContainer`,
};

const StyledGridColumn = styled(GridColumn)((
	{
		theme,
	},
) => ({
	[`&.${classes.compositionContainer}`]: {
		backgroundColor: "white",
		borderRadius: "3px",
		marginBottom: 12,
		padding: 8,
	},
}));

interface HiggMaterialCompositionSingleItemProps {
	item: HiggMaterialComposition;
}
const HiggMaterialCompositionSingleItem: FunctionComponent<HiggMaterialCompositionSingleItemProps> = observer((props) => {
	const {
		item,
	} = props;
	const {
		blendPercentage,
		defaultProcess,
		compositionNode,
		fetchProcesses,
		isEdit,
		compositionKey,
		percentageIsInvalid,
		process,
		processItems,
		setBlendPercentage,
		setProcess,
	} = item;

	const { removeComposition } = useHiggMaterialStore();
	const loc = useLocale();
	const name = loc.getNodeName(compositionNode);

	useEffectAsync(async () => {
		await fetchProcesses();
	}, []);

	useEffect(() => {
		// when default process is ready, select it if not in the case of editing
		if (defaultProcess && !isEdit) {
			setProcess(null, defaultProcess, null);
		}
	}, [defaultProcess]);

	return (
		<StyledGridColumn
			className={classes.compositionContainer}
			growAllChildren
			spacing={2}
			spacingAround={2}
		>
			<GridRow
				alignItems="center"
				flexWrap="nowrap"
				growChild={0}
			>
				<OverflowText text={name} />
				<IconButton onClick={() => removeComposition(compositionKey)} size="small">
					<CloseIcon />
				</IconButton>
			</GridRow>
			{processItems && (
				<SingleSelect
					fullWidth
					onChange={setProcess}
					options={processItems}
					placeHolder="HiggProcess"
					required
					tooltipPlacement="left"
					value={process}
				/>
			)}
			<TextField
				InputProps={{
					endAdornment:
						<InputAdornment position="end">
							{loc.resource("PercentageSign")}
						</InputAdornment>,
				}}
				error={percentageIsInvalid}
				onChange={setBlendPercentage}
				placeholderRes="HiggBlendPercentage"
				required
				selectOnFocus
				type="number"
				value={blendPercentage}
			/>
		</StyledGridColumn>
	);
});

export default HiggMaterialCompositionSingleItem;